<template>
    <div v-show="visible">
        <el-dialog title="作业附件" :close-on-click-modal="false" v-loading="loading" :visible.sync="visible"
            :before-close="dialogClose" width="450px">

            <el-table :data="data" style="width: 100%;margin-bottom: 20px;" row-key="roleId" height="250"
                v-loading="loading" element-loading-background="rgba(255, 255,255,0.7)"
                element-loading-text="数据正在加载中..." border fit highlight-current-row>
                <el-table-column type="index" label="序号" fixed width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="附件">
                    <template slot-scope="scope">
                        <div v-if="scope.row.fileType == 1">
                            <div v-if="scope.row.url != null && scope.row.url != ''">
                                <el-popover placement="right" title="" trigger="hover">
                                    <img :src="scope.row.url" lazy="loading"
                                        style="max-height:250px; max-width:330px" />
                                    <img slot="reference" :src="scope.row.url" lazy="loading" :alt="scope.row.url"
                                        style="max-height: 50px;max-width: 130px">
                                </el-popover>
                            </div>
                            <div v-else>
                                未上传
                            </div>
                        </div>
                        <div v-else-if="scope.row.fileType == 2">
                            <a target="_blank" :href="scope.row.url">查看录音</a>
                        </div>
                        <div v-else-if="scope.row.fileType == 3">
                            <a target="_blank" :href="scope.row.url">查看视频</a>
                        </div>
                        <div v-else-if="scope.row.fileType == 4">
                            <a target="_blank" :href="scope.row.url">进入链接</a>
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="附件类型">
                    <template slot-scope="scope">
                        <div v-if="scope.row.fileType == 1">
                            图片
                        </div>
                        <div v-else-if="scope.row.fileType == 2">
                            录音
                        </div>
                        <div v-else-if="scope.row.fileType == 3">
                            视频
                        </div>
                        <div v-else-if="scope.row.fileType == 4">
                            链接
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="80px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button style="color: red" @click.native.prevent="del(scope.row)" type="text" size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import http from '../../../common/http';

export default {
    data() {
        return {
            visible: false,
            loading: false,
            form: {
                deptId: "",
                studentTaskId: ""
            },
            data: []

        }
    },
    created: function () {
    },
    methods: {
        init(deptId, studentTaskId) {
            if (this.$refs['form'] != undefined) {
                this.$refs['form'].resetFields();
            }
            this.visible = true;
            this.form.deptId = deptId;
            this.form.studentTaskId = studentTaskId;

            this.getData();
        },
        indexMethod(index) {
            return index + 1;
        },
        dialogClose(done) {
            done();
            this.$reload;
        },
        getData() {
            let url = this.studenfileListUrl;
            let data = {
                deptId: this.form.deptId,
                studentTaskId: this.form.studentTaskId
            };
            // console.log(data);
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.data = res.data.list;
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            });
        },
        //删除
        del(data) {
            this.form.id = data.id;
            this.$commonFn.showConfirm(this.delSuccess);
        },
        delSuccess() {
            let url = this.studenfileRemoveUrl;
            let data = {
                id: this.form.id
            };
            this.apiPost(url, data).then((res) => {
                if (res.status === 200) {
                    this.$commonFn.showTip(res.message, 1);
                    this.getData();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            })
        }
    },
    mixins: [http]
}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/StudentFile.vue